import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import { useFlagStore } from '@/store';
import AboutPage from '../views/AboutPage.vue';
import JoinGamePage from '../views/JoinGamePage.vue';
import { useSpeechRecognition } from '@/plugins/speechrecognition';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    beforeEnter: async (to, from, next) => {
      const store = useFlagStore();
      if (store.getMyPlayer) {
        store.leaveThisGame();
      }
      next();
    }
  },
  {
    path: '/joingame',
    name: 'JoinGamePage',
    component: JoinGamePage
  },
  {
    path: '/waitforgamestart',
    name: 'WaitForGameStartPage',
    component: () => import('../views/WaitForGameStartPage.vue')
  },
  {
    path: '/game',
    name: 'GamePage',
    component: () => import('../views/GamePage.vue'),
    beforeEnter: (to, from, next) => {
      const store = useFlagStore();
      if (!store.getMyPlayer) {
        next({ name: 'HomePage' });
      } else {
        next();
      }
    }
  },
  {
    path: '/gameend',
    name: 'GameEnd',
    component: () => import('../views/GameEnd.vue'),
    beforeEnter: (to, from, next) => {
      const store = useFlagStore();
      if (!store.getFinishedGame) {
        next({ name: 'HomePage' });
      } else {
        next();
      }
    }
  },
  {
    path: '/about',
    name: 'AboutPage',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutPage
  }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
});

/* bij elke beforeEach reroute wordt beforeEach (nogmaals) uitgevoerd!*/
router.beforeEach(async (to) => {
  const store = useFlagStore();
  const speech = useSpeechRecognition();
  speech.stopRecognition();
  if (!store.isMounted) {
    await store.mount();
  }
  return true;
});
export default router;
